export const PERMISSION_DENIES = {
  LIMITED_DELIVERIES: 'EJ_ALLA_LEVERANSSATT', //  Endast självscanning och butiksexpress
  VIEW_PRICES: 'EJ_SE_PRISER',
  CHANGE_ASSORTMENT: 'EJ_ANDRA_SORTIMENT',
  PLACE_ORDER: 'EJ_ORDER',
  VIEW_ORDER_HISTORY: 'EJ_ORDERHISTORIK',
  CREATE_QUOTE: 'EJ_SKAPA_OFFERT',
  VIEW_DISCOUNTS: 'EJ_SE_RABATTER',
  SEE_FINANCIAL_FOLLOW_UP: 'EJ_SE_EKONOMISK_UPPFÖLJNING',
};
